export enum ThumbValue {
  UP = 'UP',
  DOWN = 'DOWN',
}
